module.exports = __webpack_public_path__ + "assets/img/logo-mynavi-doctor.612d072e.svg";